<template>
  <div class="goods-grid" ref="grid">
    <div v-for="goods in rows" :key="goods.materialId" class="goods-cell" @click="handleClick(goods)">
      <span v-if="goods.discountExcluded === 1 || goods.discountExcluded === true" class="no-discount-tag">无折</span>
      <div class="goods-img">
        <img v-if="goods.imgName" :src="imgUrl(goods.imgName)" />
        <div v-else class="img-placeholder">{{ goods.name }}</div>
      </div>
      <div class="goods-name" :title="goods.name">{{ goods.name }}</div>
      <div class="goods-price">
        <template v-if="goods.minPrice !== null && goods.minPrice !== undefined">
          <span v-if="hasMemberPrice(goods)" class="member-price">¥{{ format(goods.minPrice) }}</span>
          <span v-if="hasMemberPrice(goods)" class="origin-price">¥{{ format(goods.minRetail) }}</span>
          <span v-if="!hasMemberPrice(goods)" class="normal-price">¥{{ format(goods.minPrice) }}</span>
        </template>
        <span v-else class="normal-price">--</span>
        <span v-if="goods.units && goods.units.length > 1" class="spec-tag">多规格</span>
      </div>
    </div>
    <div v-if="!rows || !rows.length" class="empty-tip">暂无商品</div>
  </div>
</template>

<script>
  import { getFileAccessHttpUrl } from '@/api/manage'

  /**
   * 商品格子：4~6 列随容器宽度自适应（CSS grid auto-fill），
   * 显示图片/名称/价格（会员价 + 原价划线）
   */
  export default {
    name: 'GoodsGrid',
    props: {
      rows: { type: Array, default: () => [] }
    },
    methods: {
      imgUrl(imgName) {
        return getFileAccessHttpUrl('systemConfig/static/' + imgName.split(',')[0])
      },
      format(price) {
        const n = Number(price)
        return isNaN(n) ? '--' : n.toFixed(2)
      },
      /** 任一单位行应用价低于零售价（等级会员价或等级折扣）即显示会员价样式 */
      hasMemberPrice(goods) {
        return goods.units && goods.units.some(u =>
          Number(u.price) !== Number(u.retailPrice))
      },
      handleClick(goods) {
        this.$emit('pick', goods)
      }
    }
  }
</script>

<style scoped>
  .goods-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    grid-auto-rows: minmax(150px, auto);
    gap: 10px;
    overflow-y: auto;
    height: 100%;
    padding: 4px;
  }
  .goods-cell {
    background: #fff;
    border: 1px solid #eee;
    border-radius: 6px;
    padding: 6px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
  }
  .no-discount-tag {
    position: absolute;
    right: 4px;
    top: 4px;
    z-index: 2;
    font-size: 10px;
    color: #fff;
    background: #999;
    border-radius: 3px;
    padding: 0 4px;
  }
  .goods-cell:hover {
    border-color: #0081ff;
    box-shadow: 0 0 6px rgba(0, 129, 255, .2);
  }
  .goods-img {
    height: 90px;
    background: #fafafa;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .goods-img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .img-placeholder {
    color: #bbb;
    font-size: 12px;
    text-align: center;
    padding: 0 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .goods-name {
    margin-top: 6px;
    font-size: 13px;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .goods-price {
    margin-top: 4px;
    position: relative;
  }
  .member-price {
    color: #e4393c;
    font-size: 15px;
    font-weight: 600;
  }
  .origin-price {
    color: #999;
    font-size: 12px;
    text-decoration: line-through;
    margin-left: 4px;
  }
  .normal-price {
    color: #333;
    font-size: 15px;
    font-weight: 600;
  }
  .spec-tag {
    position: absolute;
    right: 0;
    top: 2px;
    font-size: 10px;
    color: #0081ff;
    border: 1px solid #0081ff;
    border-radius: 3px;
    padding: 0 3px;
  }
  .empty-tip {
    grid-column: 1 / -1;
    text-align: center;
    color: #bbb;
    padding: 40px 0;
  }
</style>
